import { render, staticRenderFns } from "./HandheldScanner.vue?vue&type=template&id=02804ff3&scoped=true&"
import script from "./HandheldScanner.vue?vue&type=script&lang=js&"
export * from "./HandheldScanner.vue?vue&type=script&lang=js&"
import style0 from "./HandheldScanner.vue?vue&type=style&index=0&id=02804ff3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02804ff3",
  null
  
)

export default component.exports